import { render } from "./BatchDetails.vue?vue&type=template&id=3a370260&scoped=true"
import script from "./BatchDetails.vue?vue&type=script&lang=js"
export * from "./BatchDetails.vue?vue&type=script&lang=js"

import "./BatchDetails.vue?vue&type=style&index=0&id=3a370260&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a370260"]])

export default __exports__